<template>
  <Modal
    :modal-style="{ maxWidth: '1440px' }"
    title="Remove Articles from Syndication"
  >
    <div v-if="hasSiblings">
      <table>
        <thead>
          <tr>
            <th>
              <Checkbox
                :model-value="allSelected"
                new-design
                @update:model-value="toggleSelectAll"
              />
            </th>
            <th>ID</th>
            <th>Publisher</th>
            <th>Title</th>
            <th>URL</th>
            <th>Published At</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="sibling in siblings"
            :key="sibling.id"
          >
            <td>
              <Checkbox
                v-model="selectedArticles"
                new-design
                :value="sibling.id"
              />
            </td>
            <td>{{ sibling.id }}</td>
            <td>{{ dig(sibling, "source", "name") }}</td>
            <td>{{ sibling.title }}</td>
            <td>
              <a
                :href="sibling.public_link"
                rel="noopener noreferrer"
                target="_blank"
              >
                {{ displayUrlText(sibling) }}
              </a>
            </td>
            <td>
              {{
                formatIntlDate(sibling.published_at, {
                  dateStyle: "short",
                  timeStyle: "medium",
                })
              }}
            </td>
            <td>
              {{
                formatIntlDate(sibling.created_at, {
                  dateStyle: "short",
                  timeStyle: "medium",
                })
              }}
            </td>
          </tr>
        </tbody>
      </table>
      <BaseButton
        class="q-mt-md"
        color="danger"
        label="Remove selected articles from Syndication"
        new-design
        @click="submitSelection"
      />
    </div>
    <div v-else>
      <p>No syndicated articles available.</p>
    </div>
  </Modal>
</template>

<script>
import BaseButton from "shared/components/base/BaseButton.vue";
import Checkbox from "shared/components/core/forms/Checkbox.vue";
import Modal from "shared/components/core/modals/Modal.vue";
import { formatIntlDate } from "shared/helpers/date";
import { dig } from "shared/helpers/object";

export default {
  name: "SyndicatedArticlesModal",
  components: { BaseButton, Checkbox, Modal },
  props: {
    siblings: {
      type: Array,
      required: true,
    },
    articleType: {
      type: String,
      required: true,
    },
  },
  emits: ["submit"],
  data() {
    return {
      selectedArticles: [],
    };
  },
  computed: {
    hasSiblings() {
      return this.siblings && this.siblings.length > 0;
    },
    allSelected() {
      return (
        this.siblings.length > 0 &&
        this.selectedArticles.length === this.siblings.length
      );
    },
    apiEndpoint() {
      const endpoints = {
        Online: "articles/remove_articles_from_syndication",
        Paper: "paper_articles/remove_articles_from_syndication",
      };

      return endpoints[this.articleType];
    },
  },
  methods: {
    dig,
    formatIntlDate,
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedArticles = [];
      } else {
        this.selectedArticles = this.siblings.map((sibling) => sibling.id);
      }
    },
    displayUrlText(sibling) {
      if (this.articleType === "Online") return sibling.url;
      if (this.articleType === "Paper")
        return `${sibling.public_url.slice(0, 60)}...`;

      return sibling.url || null;
    },
    async submitSelection() {
      try {
        await this.$streemApiAdmin.post(this.apiEndpoint, {
          params: {
            article_ids: this.selectedArticles,
          },
        });

        const remainingArticles = this.siblings.filter(
          (sibling) => !this.selectedArticles.includes(sibling.id)
        );

        this.$emit("submit", remainingArticles);
        this.$modals.close("SyndicatedArticlesModal");
      } catch (error) {
        this.$error("Failed to remove articles from syndication.", error);
      }
    },
  },
};
</script>
